function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

const SvgComponent = ({
  fill = '#4c505b',
  width = '1em',
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 473.487 473.487",
  width: width
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M473.487 182.08l-162.872-24.127L235.904 11.23l-73.276 147.445L0 184.389l117.584 115.252-25.798 162.616 145.947-76.215 146.684 74.787-27.385-162.355L473.487 182.08zM237.568 352.284L130.759 408.06l18.88-119.007-86.052-84.346 119.017-18.819 53.625-107.905 54.676 107.376L410.1 203.017l-85.225 85.181 20.041 118.817-107.348-54.731z",
  fill: fill
}));

export default SvgComponent;